import React from 'react';
import './InsightsSummary.css';

function InsightsSummary({ summary }) {
  if (!summary) return null;

  // Only show title if we have celebrateWins, otherwise it's just growth areas
  const showTitle = summary.celebrateWins && summary.celebrateWins.length > 0;

  return (
    <div className="insights-summary">
      {showTitle && <h3 className="insights-summary__title">Your Journey Summary</h3>}

      {/* Wins to Celebrate */}
      {summary.celebrateWins && summary.celebrateWins.length > 0 && (
        <section className="insights-summary__section insights-summary__section--celebrate">
          <div className="insights-summary__section-header">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <h4>Celebrate Your Wins</h4>
          </div>
          <ul className="insights-summary__list">
            {summary.celebrateWins.map((win, index) => (
              <li key={index} className="insights-summary__list-item insights-summary__list-item--win">
                <span className="insights-summary__list-icon">✨</span>
                <span>{win}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* Areas of Growth */}
      {summary.areasOfGrowth && summary.areasOfGrowth.length > 0 && (
        <section className="insights-summary__section insights-summary__section--growth">
          <div className="insights-summary__section-header">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
            </svg>
            <h4>Areas to Explore</h4>
          </div>
          <ul className="insights-summary__list">
            {summary.areasOfGrowth.map((growthArea, index) => (
              <li key={index} className="insights-summary__list-item insights-summary__list-item--growth">
                <div className="insights-summary__growth-header">
                  <span className="insights-summary__list-icon">🌱</span>
                  <strong>{growthArea.area}</strong>
                </div>
                <div className="insights-summary__growth-details">
                  <div className="insights-summary__growth-progress">
                    <span className="insights-summary__growth-label">Current: {growthArea.current}</span>
                    <span className="insights-summary__growth-label">Target: {growthArea.target}</span>
                  </div>
                  <div className="insights-summary__progress-bar">
                    <div 
                      className="insights-summary__progress-fill" 
                      style={{ width: `${growthArea.progress}%` }}
                    ></div>
                  </div>
                  <p className="insights-summary__growth-suggestion">{growthArea.suggestion}</p>
                  <p className="insights-summary__growth-impact"><em>{growthArea.impact}</em></p>
                </div>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}

export default InsightsSummary;
